import React from "react";
import Container from "@mui/material/Container";
import Layout from "../../layouts";
import GiftCardWorking from "../DASHBOARD/GiftCardWorking";
import Typography from "@mui/material/Typography";
import { Button, Collapse, Grid } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import useMediaQuery from "@mui/material/useMediaQuery";
import HeaderBanner from "../../assets/others/privacy-policy.png";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Box, List, ListItem, ListItemText } from "@mui/material";
import PageBreadcrumb from "../../components/other/PageBreadcrumb";
import { NavLink } from "react-router-dom";
import {
  Info,
  LockKeyhole,
  FileText,
  Users,
  Cookie,
  ShieldCheck,
  Database,
  Bell,
  Baby,
  Share2,
  Scale,
  RefreshCw,
  Mail,
  ChevronDown,
  User,
  ShoppingCart,
  Monitor,
  Globe2,
  MailQuestion,
} from "lucide-react";

const PrivacyPolicy = (props) => {
  const { isMobile = false } = props;
  const Mobile = useMediaQuery("(max-width:480px)");
  const backgroundColor = Mobile ? "#fff" : "white.main";
  const location = useLocation();
  const canonicalUrl = `https://www.99gift.ae${location.pathname}`;

  const giftCardContiner = {
    boxShadow: { xs: 0, sm: 1, md: 2 },
    borderRadius: { xs: 0, sm: 1, md: 3 },
    p: { xs: 0, sm: 2, md: 3 },
    my: { xs: 2, sm: 3, md: 3 },
    backgroundColor: backgroundColor,
  };

  const giftCardStyle = {
    my: { xs: 0, md: 0 },
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Privacy Policy - 99Gift</title>
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content="Privacy Policy - 99Gift" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {!isMobile && (
        <Container maxWidth="xl">
          <PageBreadcrumb home="Home" currentProduct="Privacy Policy" />
        </Container>
      )}

      <Container
        maxWidth="false"
        disableGutters
        sx={{ position: "relative", zIndex: 1 }}
      >
        <Box
          sx={{
            objectFit: "cover",
            minHeight: {
              xs: "130px",
              sm: "130px",
              md: "130px",
              lg: "216px",
            },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={HeaderBanner}
            alt="Header Banner"
            style={{ objectFit: "contain", width: "100%", height: "100%" }}
          />
        </Box>
      </Container>

      <Container
        maxWidth={false}
        disableGutters
        sx={{
          backgroundColor: "#F1F5F6",
          "@media (max-width:480px)": {
            backgroundColor: "white",
          },
        }}
      >
        <Grid
          container
          spacing={{ xs: 0, md: 3 }}
          alignItems="flex-start"
          sx={{
            height: {
              xs: "auto",
              md: "calc(100vh - 100px)",
            },
            overflow: {
              xs: "visible",
              md: "hidden",
            },
            px: { xs: 0, md: 3 },
          }}
        >
          {/* LEFT SIDEBAR */}
          <Grid
            item
            xs={12}
            md="auto"
            sx={{
              display: { xs: "none", md: "block" },
              height: "100%",
              flexShrink: 0,
            }}
          >
            <PrivacyPolicySidebar />
          </Grid>

          {/* RIGHT CONTENT */}
          <Grid
            item
            xs={12}
            md
            sx={{
              minWidth: 0,
              height: {
                xs: "auto",
                md: "100%",
              },
              overflowY: {
                xs: "visible",
                md: "auto",
              },
              overflowX: "hidden",

              // Optional scrollbar styling
              "&::-webkit-scrollbar": { display: "none" }, // Chrome, Safari, Edge
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE
            }}
          >
            {/* 1. Introduction */}
            <Box
              id="introduction"
              sx={{
                scrollMarginTop: "20px",
              }}
            >
              <PrivacyPolicyUse giftCardContiner={giftCardContiner} />
            </Box>

            {/* 2. Information We Collect */}
            <Box
              id="information-we-collect"
              sx={{
                scrollMarginTop: "20px",
              }}
            >
              <PrivacyPolicyDisclosure giftCardContiner={giftCardContiner} />
            </Box>

            {/* Remaining Sections */}
            <PrivacyPolicyMainSections giftCardContiner={giftCardContiner} />
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default PrivacyPolicy;

const PrivacyPolicySidebar = () => {
  const sections = [
    {
      id: "introduction",
      title: "Introduction",
      icon: <Info size={15} />,
    },
    {
      id: "information-we-collect",
      title: "Information We Collect",
      icon: <LockKeyhole size={15} />,
    },
    {
      id: "how-we-use",
      title: "How We Use Information",
      icon: <FileText size={15} />,
    },
    {
      id: "information-sharing",
      title: "Information Sharing",
      icon: <Users size={15} />,
    },
    {
      id: "cookies",
      title: "Cookies & Tracking",
      icon: <Cookie size={15} />,
    },
    {
      id: "data-security",
      title: "Data Security",
      icon: <ShieldCheck size={15} />,
    },
    {
      id: "data-retention",
      title: "Data Retention",
      icon: <Database size={15} />,
    },
    {
      id: "privacy-rights",
      title: "Your Privacy Rights",
      icon: <LockKeyhole size={15} />,
    },
    {
      id: "marketing",
      title: "Marketing Communications",
      icon: <Bell size={15} />,
    },
    {
      id: "children",
      title: "Children's Privacy",
      icon: <Baby size={15} />,
    },
    {
      id: "third-party",
      title: "Third-Party Services",
      icon: <Share2 size={15} />,
    },
    {
      id: "uae-compliance",
      title: "UAE Privacy & Compliance",
      icon: <Scale size={15} />,
    },
    {
      id: "policy-updates",
      title: "Policy Updates",
      icon: <RefreshCw size={15} />,
    },
    {
      id: "contact-us",
      title: "Contact Us",
      icon: <Mail size={15} />,
    },
  ];

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Box
      sx={{
        display: {
          xs: "none",
          md: "block",
        },
        position: "sticky",
        top: "50px",
        alignSelf: "flex-start",
      }}
    >
      <Box
        sx={{
          width: "250px",
          backgroundColor: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          p: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        }}
      >
        {/* Heading */}
        <Typography
          sx={{
            color: "#245b94",
            fontSize: "14px",
            fontWeight: 700,
            mb: 1.5,
            textTransform: "uppercase",
          }}
        >
          On This Page
        </Typography>

        {/* Links */}
        <Box>
          {sections.map((section) => (
            <Box
              key={section.id}
              onClick={() => handleScroll(section.id)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                py: 0.75,
                px: 0.5,
                color: "#4b5563",
                cursor: "pointer",
                borderRadius: "4px",
                transition: "all 0.2s ease",

                "&:hover": {
                  color: "#245b94",
                  backgroundColor: "#f5f9fd",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  color: "#64748b",
                }}
              >
                {section.icon}
              </Box>

              <Typography
                 sx={{
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: 1,
    color: "inherit",
  }}
              >
                {section.title}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Bottom Trust Box */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: "7px",
            backgroundColor: "#eef8ff",
            display: "flex",
            gap: 1,
            alignItems: "flex-start",
          }}
        >
          <ShieldCheck
            size={27}
            color="#28a745"
            style={{
              flexShrink: 0,
            }}
          />

          <Box>
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 700,
                color: "#34516d",
                mb: 0.3,
              }}
            >
              Your trust is our priority.
            </Typography>

            <Typography
              sx={{
                fontSize: "9.5px",
                lineHeight: 1.4,
                color: "#667788",
              }}
            >
              We are committed to keeping your data safe and secure.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};


function PrivacyPolicyAccordion({
  number,
  title,
  description,
  icon,
  iconBg = "#eaf3ff",
  iconColor = "#1976d2",
  children,
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <Box
      sx={{
        borderBottom: "1px solid #e8e8e8",
        py: { xs: 1.5, sm: 1.7 },
      }}
    >
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          gap: { xs: 1.2, sm: 1.5 },
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            flexShrink: 0,
            width: { xs: 42, sm: 48 },
            height: { xs: 42, sm: 48 },
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: iconBg,
            color: iconColor,
          }}
        >
          {icon}
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              color: "#245b94",
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "16px",
              },
              fontWeight: 600,
              lineHeight: 1.3,
            }}
          >
            {number}. {title}
          </Typography>

          <Typography
            sx={{
              mt: 0.35,
              color: "#555",
              fontSize: {
                xs: "11.5px",
                sm: "12px",
                md: "12.5px",
              },
              lineHeight: 1.45,
              display: "-webkit-box",
              WebkitLineClamp: open ? "unset" : 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {description}
          </Typography>
        </Box>

        {/* Arrow */}
        <ChevronDown
          size={18}
          color="#777"
          style={{
            flexShrink: 0,
            transition: "transform 0.2s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Box>

      {/* Expanded content */}
      <Collapse in={open}>
        <Box
          sx={{
            ml: { xs: 6, sm: 7 },
            mt: 1,
            pr: 3,
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
}

function PrivacyPolicyMainSections({ giftCardContiner }) {
  return (
    <Grid
      container
      sx={{
        ...giftCardContiner,
        display: "block",
        p: { xs: 1.5, sm: 2.5, md: 3 },
      }}
    >
      {/* 1. How We Use Your Information */}
      <Box id="how-we-use" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="2"
          title="How We Use Your Information"
          description="We may use your information to:"
          icon={<FileText size={23} />}
          iconBg="#eaf8ed"
          iconColor="#35a853"
        >
          <Box sx={{ mt: 2 }}>
            <Box
              component="ol"
              sx={{
                pl: 3,
                m: 0,
                color: "#4b5563",
                fontSize: "15px",
                fontWeight: 400,
                "& li": {
                  mb: 1,
                  pl: 0.5,
                  fontSize: "15px",
                  fontWeight: 400,
                },
              }}
            >
              <li>Create and manage your account.</li>
              <li>Process and confirm gift card purchases.</li>
              <li>Deliver digital gift cards and order information.</li>
              <li>Provide customer support.</li>
              <li>Respond to enquiries and requests.</li>
              <li>
                Manage refunds, cancellations and transaction-related issues
                where applicable.
              </li>
              <li>Improve our website, products and services.</li>
              <li>Understand website usage and customer preferences.</li>
              <li>
                Detect and prevent fraud, abuse and unauthorized activity.
              </li>
              <li>Maintain website and transaction security.</li>
              <li>Send service-related communications.</li>
              <li>Send marketing communications where permitted.</li>
              <li>Manage promotions and offers.</li>
              <li>
                Meet applicable legal, regulatory and accounting requirements.
              </li>
              <li>
                Protect our customers, systems, services and legal rights.
              </li>
            </Box>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 2. Information Sharing */}
      <Box id="information-sharing" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="3"
          title="Information Sharing"
          description="We do not sell your personal information as a commodity. We may share relevant information with trusted third parties where reasonably necessary to provide our services, complete transactions or meet legal obligations."
          icon={<Users size={23} />}
          iconBg="#f2e9ff"
          iconColor="#8e44ad"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              We do{" "}
              <strong>
                not sell your personal information as a commodity.
              </strong>
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              We may share relevant information with trusted third parties where
              reasonably necessary to provide our services, complete
              transactions or meet legal obligations.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 1.5,
              }}
            >
              This may include:
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#374151",
                mb: 1,
              }}
            >
              Payment Service Providers
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              Payment providers may receive information necessary to authorize
              and process your payment.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#374151",
                mb: 1,
              }}
            >
              Gift Card & Brand Partners
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              Where required to fulfil a gift card order, relevant transaction
              or recipient information may be shared with the applicable gift
              card provider, brand or service partner.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#374151",
                mb: 1,
              }}
            >
              Technology & Service Providers
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 1,
              }}
            >
              We may use third-party providers for:
            </Typography>

            <Box
              component="ul"
              sx={{
                pl: 3,
                mb: 2,
                "& li": {
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#4b5563",
                  mb: 0.5,
                },
              }}
            >
              <li>Website hosting</li>
              <li>Cloud infrastructure</li>
              <li>Email delivery</li>
              <li>Customer support</li>
              <li>Analytics</li>
              <li>Website performance</li>
              <li>Security</li>
              <li>Fraud prevention</li>
            </Box>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#374151",
                mb: 1,
              }}
            >
              Legal & Regulatory Authorities
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              We may disclose information where required by applicable law,
              court order, regulatory requirement or lawful government request.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 3. Cookies */}
      <Box id="cookies" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="4"
          title="Cookies & Tracking Technologies"
          description="99Gift.ae may use cookies and similar technologies to operate our website, remember preferences, understand website usage and improve our services."
          icon={<Cookie size={23} />}
          iconBg="#fff0dc"
          iconColor="#e58b19"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            {/* Essential Cookies */}
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#374151",
                mb: 1,
              }}
            >
              Essential Cookies
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 1,
              }}
            >
              These may support:
            </Typography>

            <Box
              component="ul"
              sx={{
                pl: 3,
                mb: 2,
                "& li": {
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#4b5563",
                  mb: 0.5,
                },
              }}
            >
              <li>Website functionality</li>
              <li>Account sessions</li>
              <li>Shopping and checkout</li>
              <li>Security</li>
              <li>User preferences</li>
            </Box>

            {/* Analytics Cookies */}
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#374151",
                mb: 1,
              }}
            >
              Analytics Cookies
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 1,
              }}
            >
              Where used, analytics technologies may help us understand:
            </Typography>

            <Box
              component="ul"
              sx={{
                pl: 3,
                mb: 2,
                "& li": {
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#4b5563",
                  mb: 0.5,
                },
              }}
            >
              <li>Website traffic</li>
              <li>Popular pages</li>
              <li>User interactions</li>
              <li>Website performance</li>
              <li>Technical issues</li>
            </Box>

            {/* Marketing Technologies */}
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#374151",
                mb: 1,
              }}
            >
              Marketing Technologies
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              Where applicable, marketing technologies may be used to understand
              campaign performance and provide relevant marketing experiences.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              You may manage or disable certain cookies through your browser
              settings or available cookie preference controls.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              Please note that disabling essential cookies may affect some
              website functionality.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 4. Data Security */}
      <Box id="data-security" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="6"
          title="Data Security"
          description="We use reasonable technical and organizational measures designed to
        protect your personal information against."
          icon={<ShieldCheck size={23} />}
          iconBg="#e8f8ed"
          iconColor="#28a745"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            <Box
              component="ul"
              sx={{
                pl: 3,
                mb: 2,
                "& li": {
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#4b5563",
                  mb: 0.5,
                },
              }}
            >
              <li>Unauthorized access</li>
              <li>Unauthorized disclosure</li>
              <li>Accidental loss</li>
              <li>Destruction</li>
              <li>Alteration</li>
              <li>Misuse</li>
              <li>Other unauthorized processing</li>
            </Box>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              Security measures may include access controls, authentication,
              encryption where appropriate, monitoring and other technical
              safeguards.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              However, no internet transmission or electronic storage system can
              be guaranteed to be completely secure.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 5. Data Retention */}
      <Box id="data-retention" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="7"
          title="Data Retention"
          description="We retain personal information only for as long as reasonably necessary for the purposes described in this Privacy Policy."
          icon={<Database size={23} />}
          iconBg="#eef4ff"
          iconColor="#3b73c9"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 1,
              }}
            >
              This may include retaining information to:
            </Typography>

            <Box
              component="ul"
              sx={{
                pl: 3,
                mb: 2,
                "& li": {
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#4b5563",
                  mb: 0.5,
                },
              }}
            >
              <li>Provide our services</li>
              <li>Complete and maintain transaction records</li>
              <li>Manage customer accounts</li>
              <li>Provide customer support</li>
              <li>Prevent fraud and abuse</li>
              <li>Resolve disputes</li>
              <li>Meet legal, tax, accounting or regulatory requirements</li>
              <li>Protect and enforce our legal rights</li>
            </Box>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              When information is no longer required, we may securely delete,
              anonymize or otherwise dispose of it in accordance with applicable
              requirements.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 6. Your Privacy Rights */}
      <Box id="privacy-rights" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="8"
          title="Your Privacy Rights"
          description="Depending on applicable law and the circumstances of processing, you may have rights relating to your personal information."
          icon={<LockKeyhole size={23} />}
          iconBg="#eaf3ff"
          iconColor="#1976d2"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 1,
              }}
            >
              These may include:
            </Typography>

            <Box
              component="ul"
              sx={{
                pl: 3,
                mb: 2,
                "& li": {
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#4b5563",
                  mb: 0.5,
                },
              }}
            >
              <li>Requesting access to your personal information</li>
              <li>Requesting correction of inaccurate information</li>
              <li>Requesting deletion where legally applicable</li>
              <li>Requesting restriction of certain processing</li>
              <li>Objecting to certain types of processing</li>
              <li>Withdrawing consent where processing is based on consent</li>
              <li>Managing marketing communication preferences</li>
              <li>Raising a privacy-related concern or complaint</li>
            </Box>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              These rights may be subject to legal, contractual or other
              applicable limitations.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 7. Marketing Communications */}
      <Box id="marketing" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="9"
          title="Marketing Communications"
          description="If you have opted in to receive promotional communications, we may send information about new gift cards, special offers, promotions, new brands, seasonal campaigns, and relevant products and services."
          icon={<Bell size={23} />}
          iconBg="#fff4e5"
          iconColor="#e58b19"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            <Box
              component="ul"
              sx={{
                pl: 3,
                mb: 2,
                "& li": {
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#4b5563",
                  mb: 0.5,
                },
              }}
            >
              <li>New gift cards</li>
              <li>Special offers</li>
              <li>Promotions</li>
              <li>New brands</li>
              <li>Seasonal campaigns</li>
              <li>Relevant products and services</li>
            </Box>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              You can unsubscribe from marketing communications using the
              unsubscribe option provided in the relevant communication or by
              contacting us.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              You may still receive essential service-related communications
              such as order confirmations, transaction updates, security notices
              or important account information.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 8. Children's Privacy */}
      <Box id="children" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="10"
          title="Children's Privacy"
          description="99Gift.ae services are not intentionally directed toward children who are below the applicable minimum age for providing personal information without appropriate authorization."
          icon={<Baby size={23} />}
          iconBg="#f2e9ff"
          iconColor="#8e44ad"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              We do not knowingly collect personal information from children in
              circumstances where such collection is prohibited by applicable
              law.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              If you believe that a child has provided personal information to
              us improperly, please contact us so that we can review the matter
              and take appropriate action where required.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 9. Third-Party Services & Links */}
      <Box id="third-party" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="11"
          title="Third-Party Services & Links"
          description="Our website may contain links, integrations or references to third-party websites, brands, payment providers or other services."
          icon={<Share2 size={23} />}
          iconBg="#eef4ff"
          iconColor="#3b73c9"
        >
          <Box
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              Third-party services operate under their own privacy policies and
              terms.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
                mb: 2,
              }}
            >
              99Gift.ae is not responsible for the privacy practices, security
              or content of third-party websites that we do not control.
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#4b5563",
              }}
            >
              We recommend reviewing the relevant third party's privacy policy
              before providing personal information.
            </Typography>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 10. UAE Privacy & Compliance */}
      <Box id="uae-compliance" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="12"
          title="UAE Privacy & Compliance"
          description="99Gift.ae aims to handle personal information responsibly and in accordance with applicable data-protection requirements in the United Arab Emirates."
          icon={<Scale size={23} />}
          iconBg="#f3edff"
          iconColor="#7b4bb7"
        >
          <Box
            sx={{
              fontSize: "15px",
              fontWeight: 400,
              lineHeight: 1.7,
            }}
          >
            <p>
              Where applicable to our activities, we take into account UAE
              data-protection legislation, including{" "}
              <strong>
                Federal Decree by Law No. 45 of 2021 Concerning the Protection
                of Personal Data
              </strong>
              , together with other applicable laws and regulations. (
              <a
                href="https://www.uaelegislation.gov.ae/en/legislations/1972/download"
                target="_blank"
                rel="noopener noreferrer"
              >
                UAE Legislation
              </a>
              )
            </p>

            <p>Our approach includes:</p>

            <ul>
              <li>Collecting information for legitimate and stated purposes</li>
              <li>
                Limiting collection to information reasonably necessary for
                those purposes
              </li>
              <li>
                Taking reasonable measures to protect personal information
              </li>
              <li>Respecting applicable individual privacy rights</li>
              <li>
                Retaining information only as reasonably necessary or legally
                required
              </li>
              <li>
                Using appropriate safeguards when working with service providers
              </li>
            </ul>

            <p>
              The specific legal requirements applicable to a particular
              transaction or service may depend on the nature of the service,
              customer, location and other circumstances.
            </p>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 11. International Data Processing */}
      <Box id="international-data" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="13"
          title="International Data Processing"
          description="Some of our technology, hosting, payment, communication, analytics or service providers may operate from locations outside the UAE."
          icon={<Globe2 size={23} />}
          iconBg="#eaf6ff"
          iconColor="#1976d2"
        >
          <Box
            sx={{
              fontSize: "15px",
              fontWeight: 400,
              lineHeight: 1.7,
              "& p, & li": {
                fontSize: "15px",
                fontWeight: 400,
              },
            }}
          >
            <p>
              Where personal information is transferred or processed outside the
              UAE, we will seek to do so in accordance with applicable
              data-protection requirements and appropriate safeguards.
            </p>

            <p>
              The actual locations and providers used by 99Gift.ae may change as
              our services develop and as we work with different technology and
              service providers.
            </p>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 12. Policy Updates */}
      <Box id="policy-updates" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="14"
          title="Policy Updates"
          description="We may update this Privacy Policy from time to time to reflect changes to our services, technology, business operations, applicable laws or regulations, and our privacy practices."
          icon={<RefreshCw size={23} />}
          iconBg="#eef7f0"
          iconColor="#35a853"
        >
          <Box
            sx={{
              fontSize: "15px",
              fontWeight: 400,
              lineHeight: 1.7,
              "& p, & li": {
                fontSize: "15px",
                fontWeight: 400,
              },
            }}
          >
            <p>
              We may update this Privacy Policy from time to time to reflect:
            </p>

            <ul>
              <li>Changes to our services</li>
              <li>New website features</li>
              <li>Changes in technology</li>
              <li>Changes in business operations</li>
              <li>Changes in applicable laws or regulations</li>
              <li>Changes in our privacy practices</li>
            </ul>

            <p>
              When we make changes, we will update the{" "}
              <strong>“Last Updated”</strong> date at the top of this page.
            </p>

            <p>
              We encourage you to review this page periodically to remain
              informed about how we handle personal information.
            </p>
          </Box>
        </PrivacyPolicyAccordion>
      </Box>

      {/* 13. Contact Us */}
      <Box id="contact-us" sx={{ scrollMarginTop: "20px" }}>
        <PrivacyPolicyAccordion
          number="15"
          title="Questions About Your Privacy?"
          description="If you have any questions about this Privacy Policy, want to exercise an applicable privacy right, or have a concern about how your personal information is handled, please contact us."
          icon={<MailQuestion size={23} />}
          iconBg="#fff0f0"
          iconColor="#d64545"
        >
          <Box
            sx={{
              fontSize: "15px",
              fontWeight: 400,
              lineHeight: 1.7,
              "& p, & li": {
                fontSize: "15px",
                fontWeight: 400,
              },
            }}
          >
            <p>
              <strong>99Gift.ae</strong>
            </p>

            <p>
              <strong>Website:</strong>{" "}
              <a
                href="https://99gift.ae"
                target="_blank"
                rel="noopener noreferrer"
              >
                99gift.ae
              </a>
            </p>

            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:info@99gift.ae">info@99gift.ae</a>
            </p>

            <p>
              When contacting us about a privacy request, please include enough
              information for us to understand and process your request.
            </p>

            <p>
              We may need to verify your identity before responding to certain
              requests in order to protect your personal information.
            </p>

            {/* <Box sx={{ mt: 2 }}>
        <strong>CTA</strong>
        <Box sx={{ mt: 1 }}>
          <Button
            variant="contained"
            href="mailto:info@99gift.ae"
            sx={{
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            Contact Us
          </Button>
        </Box>
      </Box> */}
          </Box>
        </PrivacyPolicyAccordion>
      </Box>
    </Grid>
  );
}

function PrivacyPolicyUse({ giftCardContiner }) {
  const orders = [
    {
      content:
        "Various options: You get to choose from over 160 options of Gift Cards. So, every shopper get almost everything according to their needs.",
    },
    {
      content:
        "Major discounts: Various types of gift cards come with discounts which reduces the load from your budget.",
    },
    {
      content:
        "Simple buying and redemption of Gift Cards: You can buy Gift cards easily in a small amount of time from our portal and also from 99gift application.",
    },
    {
      content:
        "Great substitution for Gifting: With Gift cards, you can give your loved ones something which is totally in use.Find a range of Gifting options for all occasions like Diwali, birthdays, New Year, anniversaries, etc. You can also send them instantly on Valentine's Day, Father’s Day, Mother’s Day, and other such special days.",
    },
    {
      content:
        "Great for the environment: We don’t use or issue plastic Cards that are harmful to the environment. Everything is online; which you contribute to the planet by buying a voucher from here.",
    },
    {
      content:
        "Environment friendly options: We don’t issue physical/plastic gift cards neither we encourage the use of the plastic, since it is harmful for the environment. Gift cards are online and you can contribute in Green Revolution by purchasing from here.",
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <Box sx={{ width: "100%" }}>
            {/* Last Updated Box */}
            <Box
              sx={{
                backgroundColor: "#eef7ff",
                border: "1px solid #dcecf9",
                borderRadius: "7px",
                px: { xs: 2, md: 2.5 },
                py: { xs: 1.5, md: 2 },
                mb: { xs: 2.5, md: 3 },
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* Calendar Icon */}
              <CalendarMonthOutlinedIcon
                sx={{
                  color: "#3b82f6",
                  fontSize: { xs: 20, md: 22 },
                  mr: 1,
                }}
              />

              <Typography
                sx={{
                  fontSize: { xs: "13px", md: "15px" },
                  color: "#1f2937",
                  fontWeight: 600,
                }}
              >
                Last Updated:
                <Box
                  component="span"
                  sx={{
                    fontWeight: 400,
                    ml: "4px",
                  }}
                >
                  August 20, 2026
                </Box>
              </Typography>
            </Box>

            {/* Paragraph 1 */}
            <Typography
              sx={{
                fontSize: { xs: "13.5px", md: "15px" },
                color: "#333",
                fontWeight: 400,
                lineHeight: 1.6,
                mb: { xs: 2, md: 2.2 },
              }}
            >
              At 99Gift.ae, we respect your privacy and are committed to
              protecting the personal information you provide when using our
              website, purchasing digital gift cards, creating an account,
              contacting our support team, or using our services.
            </Typography>

            {/* Paragraph 2 */}
            <Typography
              sx={{
                fontSize: { xs: "13.5px", md: "15px" },
                color: "#333",
                fontWeight: 400,
                lineHeight: 1.6,
                mb: { xs: 2, md: 2.2 },
              }}
            >
              This Privacy Policy explains what information we collect, why we
              collect it, how we use and protect it, when we may share it, and
              the choices and rights available to you.
            </Typography>

            {/* Paragraph 3 */}
            <Typography
              sx={{
                fontSize: { xs: "13.5px", md: "15px" },
                color: "#333",
                fontWeight: 400,
                lineHeight: 1.6,
                pb: { xs: 2.5, md: 3 },
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              By accessing or using 99gift.ae, you acknowledge that you have
              read and understood this Privacy Policy.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function PrivacyPolicyDisclosure({ giftCardContiner }) {
  const informationCards = [
    {
      title: "Personal Information",
      icon: <User size={28} strokeWidth={2} />,
      items: [
        "Name, email, phone number",
        "Account information",
        "Billing & delivery details",
        "Support & communication information",
      ],
    },
    {
      title: "Transaction Information",
      icon: <ShoppingCart size={28} strokeWidth={2} />,
      items: [
        "Gift cards purchased",
        "Order & payment details",
        "Discounts & promotions",
        "Recipient information (where provided)",
      ],
    },
    {
      title: "Technical & Usage Information",
      icon: <Monitor size={28} strokeWidth={2} />,
      items: [
        "IP address & browser details",
        "Device & operating system",
        "Cookies & usage data",
        "Pages visited & interactions",
      ],
    },
  ];

  return (
    <Grid
      container
      sx={{
        ...giftCardContiner,
        display: "block",
        p: { xs: 2, sm: 3, md: 3 },
      }}
    >
      {/* Heading */}
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: { xs: "20px", md: "22px" },
            fontWeight: 600,
            color: "primary.main",
            mb: 0.8,
          }}
        >
          Information We Collect
        </Typography>
      </Grid>

      {/* Description */}
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: { xs: "13.5px", md: "15px" },
            color: "dark.main",
            mb: { xs: 2, md: 2.5 },
          }}
        >
          To provide our digital gift card services efficiently and securely, we
          may collect the following types of information:
        </Typography>
      </Grid>

      {/* Cards */}
      <Grid container spacing={{ xs: 1.5, sm: 2, md: 2 }}>
        {informationCards.map((card) => (
          <Grid item xs={12} sm={4} key={card.title}>
            <Box
              sx={{
                height: "100%",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                backgroundColor: "#fff",
                p: { xs: 1.8, sm: 2, md: 2.2 },
                transition: "all 0.2s ease",
                "&:hover": {
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              {/* Icon */}
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor:
                    card.title === "Personal Information"
                      ? "#eaf3ff"
                      : card.title === "Transaction Information"
                        ? "#eaf9ed"
                        : "#fff3e5",
                  color:
                    card.title === "Personal Information"
                      ? "#1976d2"
                      : card.title === "Transaction Information"
                        ? "#2e9d50"
                        : "#f57c00",
                  mb: 1.5,
                }}
              >
                {card.icon}
              </Box>

              {/* Card Title */}
              <Typography
                sx={{
                  fontSize: { xs: "14px", md: "15px" },
                  fontWeight: 600,
                  color: "#315b8a",
                  mb: 1,
                }}
              >
                {card.title}
              </Typography>

              {/* Card Items */}
              <Box
                component="ul"
                sx={{
                  m: 0,
                  pl: 2,
                  color: "dark.main",
                }}
              >
                {card.items.map((item) => (
                  <Box
                    component="li"
                    key={item}
                    sx={{
                      fontSize: {
                        xs: "12px",
                        md: "13px",
                      },
                      lineHeight: 1.5,
                      mb: 0.45,
                    }}
                  >
                    {item}
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
